import { Route } from "@angular/router";
import { AuthGuard } from "../guards/auth.guard";
import { TenantAdminGuard } from "../guards/tenant-admin.guard";

export const OrganizationSettingsRoutes: Route[] = [
  // 2026-05-06 G+3 — TenantAdminGuard added so non-admin roles can't
  // even navigate to these tenant-level settings pages. Backend
  // already enforces; this is route-level defense-in-depth.
  {
    path: "organization-settings",
    loadComponent: () =>
      import("../../Feature/organization-settings/pages/settings/organization-settings.component").then(
        (mod) => mod.OrganizationSettingsComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, TenantAdminGuard],
  },
  {
    path: "mobile-page-config",
    loadComponent: () =>
      import("../../Feature/mobile-page-config/pages/mobile-page-config/mobile-page-config.component").then(
        (mod) => mod.MobilePageConfigComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, TenantAdminGuard],
  },
];
